import getLoadingMessage from '@lib/common/loading-messages';
import { CircularProgress, Fade, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

export type PageLoadingProps = {
  children?: React.ReactNode;
  sizeOfCircularProgress?: string | number;
  [key: string]: any;
};

export function PageLoading({
  children = null,
  sizeOfCircularProgress = 40,
  style = {},
  ...props
}: PageLoadingProps) {
  return (
    <LoadingDiv style={style}>
      <CircularProgress size={sizeOfCircularProgress} />
      <Typography>{children || getLoadingMessage()}</Typography>
    </LoadingDiv>
  );
}

const LoadingDiv = styled.div`
  display: flex;
  flex-wrap: column;
  align-items: center;
  gap: 20px;
  justify-content: center;
  height: 300px;
`;
